import type { OwnerChatPendingPhoto } from '../../types/api.js';

let ownerChatLastSeenId = 0;
let ownerChatIsSending = false;
let ownerChatPendingPhoto: OwnerChatPendingPhoto | null = null;
let ownerChatPendingOutgoingId: number | null = null;

export function getOwnerChatLastSeenId() {
  return ownerChatLastSeenId;
}

export function setOwnerChatLastSeenId(value: number | string) {
  ownerChatLastSeenId = Number(value) || 0;
}

export function resetOwnerChatLastSeenId() {
  ownerChatLastSeenId = 0;
}

export function bumpOwnerChatLastSeenId(messageId: number | string | null | undefined) {
  if (messageId != null) {
    ownerChatLastSeenId = Math.max(ownerChatLastSeenId, Number(messageId));
  }
}

export function getOwnerChatIsSending() {
  return ownerChatIsSending;
}

export function setOwnerChatIsSending(value: boolean) {
  ownerChatIsSending = !!value;
}

export function getOwnerChatPendingPhoto() {
  return ownerChatPendingPhoto;
}

export function setOwnerChatPendingPhoto(value: OwnerChatPendingPhoto | null) {
  ownerChatPendingPhoto = value;
}

export function getOwnerChatPendingOutgoingId() {
  return ownerChatPendingOutgoingId;
}

export function setOwnerChatPendingOutgoingId(value: number | null) {
  ownerChatPendingOutgoingId = value;
}
